import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

var environment = document.querySelector('meta[name="rails_env"]').content

window.Sentry = Sentry

if (environment != "development") {
  Sentry.init({
    dsn: "https://cb99446d611e4521b2160a5b79b511c6@o1401350.ingest.sentry.io/6748089",
    environment: environment,
    debug: true,
    release: "headcount-js@2.0.0",
    //integrations: [new BrowserTracing()],
    maxBreadcrumbs: 30,
    attachStacktrace: true,
    tracesSampleRate: 1.0,
  });
}



import 'core-js/stable'
import 'regenerator-runtime/runtime'

import postal from 'postal'
import anime from 'animejs/lib/anime.es.js';
import * as Routes from '../routes';

// easy accessibility
window.postal = postal
window.anime = anime
window.Routes = Routes

import * as Dronelink from "dronelink-kernel"
window.Dronelink = Dronelink

//import * as Dronelink from "dronelink-kernel"
import TSP from '../tsp/TSP'
import Life from '../tsp/Life'
var FileSaver = require("file-saver")
import ExifReader from 'exifreader';

//window.Dronelink = Dronelink
window.FileSaver = FileSaver
window.TSP = TSP
window.Life = Life
window.ExifReader = ExifReader

import ReactDOM from 'react-dom';
import React from 'react';
var ReactRailsUJS = require("react_ujs");

window.ReactDOM = ReactDOM
window.React = React

var componentRequireContext = require.context("components", true);
ReactRailsUJS.useContext(componentRequireContext);

// individual reacct components that are referenced in a non conventional way
import ImportPhotos from "../components/ImportPhotos"
window.ImportPhotos = ImportPhotos

import FlagForReview from "../components/FlagForReview"
window.FlagForReview = FlagForReview

import PenComments from "../components/PenComments"
window.PenComments = PenComments

import ReactTooltip from 'react-tooltip';
window.ReactTooltip = ReactTooltip
